import { render, staticRenderFns } from "./orderLD.vue?vue&type=template&id=7021c518&scoped=true"
import script from "./orderLD.vue?vue&type=script&lang=js"
export * from "./orderLD.vue?vue&type=script&lang=js"
import style0 from "./orderLD.vue?vue&type=style&index=0&id=7021c518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7021c518",
  null
  
)

export default component.exports